import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import {
  frequencyOptions, forceChooseFrequencyOptions, forceChooseSubscribedFrequencyOptions, NEVER,
} from 'apps/subscriptions/components/fopPartials/SubscriptionsFrequencyOptions';
import { reportFrequencyChange } from 'apps/subscriptions/utils/SubscriptionsAnalytics';
import { reportRecommendationsFrequencyChange } from 'apps/subscriptions/utils/RecommendationsAnalytics';

export default class SubscriptionsFrequencySelect extends PureComponent {
  static propTypes = {
    sku: PropTypes.string.isRequired,
    frequency: PropTypes.string.isRequired,
    subscribed: PropTypes.bool.isRequired,
    onFrequencyChange: PropTypes.func.isRequired,
    onFrequencyChangeInEditMode: PropTypes.func.isRequired,
    onSubscribe: PropTypes.func,
    forceChooseFrequency: PropTypes.bool,
    isRecommendation: PropTypes.bool,
  };

  generateOptions = (options) =>
    options.map(option =>
      <option key={option.value} value={option.value}>{option.label}</option>
    );

  handleFrequencyChange = event => {
    const newFrequency = event.target.value;
    const {
      subscribed,
      sku,
      frequency,
      onFrequencyChange,
      onFrequencyChangeInEditMode,
      forceChooseFrequency,
      onSubscribe,
      isRecommendation,
    } = this.props;

    if (subscribed) {
      onFrequencyChange(sku, newFrequency);
    } else {
      onFrequencyChangeInEditMode(sku, newFrequency);
    }

    if (forceChooseFrequency
      && (!frequency || frequency === NEVER)
    ) {
      onSubscribe(sku, newFrequency);
    }

    if (isRecommendation) {
      reportRecommendationsFrequencyChange(newFrequency, sku);
    } else {
      reportFrequencyChange(newFrequency, sku);
    }
  };

  render() {
    const { frequency, forceChooseFrequency, subscribed } = this.props;
    const forceChooseFrequencies = subscribed ? forceChooseSubscribedFrequencyOptions : forceChooseFrequencyOptions;
    const frequencies = forceChooseFrequency ? forceChooseFrequencies : frequencyOptions;

    return (
      <select
        className={classNames([
          'fop-frequency',
          'gn-select__field',
          { 'sub-fop__select--never': forceChooseFrequency && (!frequency || frequency === NEVER) },
        ])}
        onChange={this.handleFrequencyChange}
        value={frequency}
      >
        {this.generateOptions(frequencies)}
      </select>
    );
  }
}
